import React, {Component} from 'react'
import {$$} from '../../../helpers/localization'
import {CONVERTER} from '../../../utils/converter'
import PropTypes from "prop-types";

export default class TemperatureForm extends Component {
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div>
                {this.props.temperature ? $$('temperature_label') : null}<br/>
                <div className="form-group">
                    <div className="input-group mb-3">
                        <input type="number" step="0.01"
                               className={this.props.errors.temperature ? "custom-error form-control" : "form-control"}
                               value={this.props.temperature} placeholder={$$('temperature_label')}
                               name="temperature" onChange={this.props.onInputChange} required/>
                        <div className="input-group-append">
                            <span className="input-group-text" style={{"height": "auto"}}
                                  id="basic-addon2">{CONVERTER.getUnitByType('TEMPERATURE')}</span>
                        </div>
                    </div>
                    <div
                        className={this.props.errors.temperature ? "custom-invalid-feedback" : "invalid-feedback"}>
                        {this.props.errors.temperature ? $$(this.props.errors.temperature) : $$('temperature_required_message')}
                    </div>
                </div>
            </div>
        )
    }
}

TemperatureForm.propTypes = {
    clearSelectedEntry: PropTypes.func,
    createEntry: PropTypes.func,
    onInputChange: PropTypes.func,
    errors: PropTypes.any,
    temperature: PropTypes.any,
    fetchSelectedUserHealthIssues: PropTypes.func,
    formDisabled: PropTypes.object,
    getHealthIssueList: PropTypes.func,
    healthIssues: PropTypes.object,
    logbookEntries: PropTypes.array,
    medicalProfile: PropTypes.object,
    onHide: PropTypes.func,
    selectedUser: PropTypes.object,
    settings: PropTypes.object,
    show: PropTypes.bool,
    type: PropTypes.string,
    updateEntry: PropTypes.func,
    updateUserMedicalProfile: PropTypes.func
}